import { useMutation } from '@apollo/client'
import omit from 'lodash/omit'
import { useTranslation } from 'react-i18next'

import { CreateRequisitionLineDocument } from '@/graphql/purchase-plus/generated/createRequisitionLine.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { useAlert } from '@/modules/shared/hooks/useAlert'
import { objectToFieldFunctions } from '@/modules/shared/utils/objectToFieldFunctions'

export function useCreateRequisitionLine(uuid: string | undefined | null) {
  const { t } = useTranslation()
  const { alertDialog } = useAlert()
  const mutation = useMutation(CreateRequisitionLineDocument, {
    context: { uri: PURCHASE_PLUS_GRAPHQL_API },
    onCompleted: ({ createRequisitionLine: { errors } }) => {
      if (errors?.length) {
        errors.forEach((error) => {
          if (error.message === 'product_id has already been taken') {
            alertDialog({
              title: t('shopPage.productList.productAddedTitle', 'Already Added to Cart'),
              message: t(
                'shopPage.productList.productAddedDescription',
                "You have already added a product exactly the same as this to your cart from a different Supplier. You can't add this product to your cart unless you remove the other product."
              ),
              buttonText: t('general.okayGotIt', 'Okay, Got It'),
              type: 'primary',
            })
          }
        })
      }
    },
    update: (cache, { data }) => {
      if (data?.createRequisitionLine.requisitionLine && uuid) {
        const newData = data.createRequisitionLine.requisitionLine
        const lineToUpdate = { __typename: 'RequisitionLine', uuid: uuid }
        const cacheId = cache.identify(lineToUpdate)
        if (cacheId) {
          cache.modify({
            id: cacheId,
            fields: objectToFieldFunctions(omit(newData, 'uuid')),
          })
        }
      }
    },
  })

  return mutation
}
